<template>
  <div>
    <van-nav-bar class="bg-gradual-blue" title="座位预约" />

    <div>
      <van-field right-icon="hotel-o" readonly clickable label="场馆:" :value="cgname" placeholder="选择场馆" @click="showSelect('cg')" />
      <van-field right-icon="calendar-o" readonly clickable label="日期:" :value="rqname" placeholder="选择日期" @click="showSelect('rq')" />
      <!-- <van-field right-icon="flag-o" readonly clickable label="时段:" :value="sdname" placeholder="选择时段" @click="showSelect('sd')" /> -->
      <van-field right-icon="tosend" readonly clickable label="开始:" :value="ksname" placeholder="选择开始时间" @click="showSelect('ks')" />
      <van-field right-icon="tosend" readonly clickable label="结束:" :value="jsname" placeholder="选择结束时间" @click="showSelect('js')" />   

      <van-popup v-model="showPicker" round position="bottom">
        <van-picker show-toolbar :columns="showList" :value-key="showkey" @cancel="showPicker = false" @confirm="onConfirm" />
      </van-popup>   
    </div>

    <div style="margin-top:20px;padding:10px 20px;">
      <van-button @click="NextStep()" style="border-radius: 0.53333rem;" type="info" block>下一步</van-button>
    </div>
  </div>
</template>

<script>
import { loadData } from '@/utils/common'
import { Toast } from 'vant';
import Seat from '@/utils/seat'

export default {
  props: {
    rdata: {
      type: Object,
      default: () => {}
    }
  },
  components: { Seat , Toast },
  data() {
    return {
      reserveObj:{},
      cgList:[],
      rqList:[],
      sdList:[],
      ksList:[],
      jsList:[],
      showList:[],
      showPicker: false,
      showkey:'name',
      selectType:'',
      cgname:'',rqname:'',sdname:'',ksname:'',jsname:''
    }
  },
  mounted() {
    this.loadCg();
  },
  methods: {
    loadCg(){
      loadData('/appSeat/queryLiblist',{}).then(response => {
        if(response && response.code == 0){
          this.cgList = response.data;
        }
      }).catch(() => {
        //this.listLoading = false
      })
    },
    showSelect(type){
      if('cg' == type){
        this.showList = this.cgList;
        this.showkey = 'name';
      }else if('rq' == type){
        if(!this.rqList || this.rqList.length < 1){
          Toast('当前场馆无可预约日期，请重新选择！');
          return;
        }
        this.showList = this.rqList;
        this.showkey = 'name';
      }else if('sd' == type){
        if(!this.sdList || this.sdList.length < 1){
          Toast('当前日期无可预约时段，请重新选择！');
          return;
        }
        this.showList = this.sdList;
        this.showkey = 'name';
      }else if('ks' == type){
        if(!this.ksList || this.ksList.length < 1){
          Toast('当前时段无可预约时间，请重新选择！');
          return;
        }
        this.showList = this.ksList;
        //this.showkey = 'name';
      }else if('js' == type){
        if(!this.jsList || this.jsList.length < 1){
          Toast('当前时间不可预约，请重新选择！');
          return;
        }
        this.showList = this.jsList;
      }else{
        this.selectType = type;
        return;
      }
      this.selectType = type;
      this.$nextTick(() => {
        this.showPicker = true;
      })
    },
    onConfirm(value,idx) {
      if('cg' == this.selectType && this.reserveObj.libId != value.id){
        this.cgname = value.name; 
        this.reserveObj.libId = value.id;
        this.reserveObj.libIdx = idx;
        this.initRq();
      }else if('rq' == this.selectType && this.reserveObj.orderDate != value.value){
        this.rqname = value.name; 
        this.reserveObj.orderDate = value.value;
        this.reserveObj.rqIdx = idx;
        //this.initSd();
		this.initKs();
      }else if('sd' == this.selectType && this.reserveObj.type != value.value){
        this.sdname = value.name; 
        this.reserveObj.type = value.value;
        this.reserveObj.sdIdx = idx;
        this.initKs();
      }else if('ks' == this.selectType && this.reserveObj.startHourStr != value){
		  //debugger;
        this.ksname = value; 
        this.reserveObj.startHourStr = value;
        this.reserveObj.ksIdx = idx;
        this.initJs();
      }else if('js' == this.selectType){
        this.jsname = value; 
        this.reserveObj.endIndex = value;
        this.reserveObj.jsIdx = idx;
      }
      this.showPicker = false;
    },
    initJs(){
      this.jsname = ''; 
      this.reserveObj.endIndex = '';
      this.reserveObj.jsIdx = '';

      let _this = this;
      Seat.loadEndTime(this.reserveObj,function(res){
        _this.jsList = res;
      });
    },
    initKs(){
      this.ksname = ''; 
      this.reserveObj.startHourStr = '';
      this.reserveObj.ksIdx = '';
      this.jsname = ''; 
      this.reserveObj.endIndex = '';
      this.reserveObj.jsIdx = '';

      let _this = this;
      Seat.loadStartTime(this.reserveObj,function(res){
        _this.ksList = res;
      });
    },
    initSd(){
      this.sdname = ''; 
      this.reserveObj.type = '';
      this.reserveObj.sdIdx = '';

      this.ksname = ''; 
      this.reserveObj.startHourStr = '';
      this.reserveObj.ksIdx = '';

      this.jsname = ''; 
      this.reserveObj.endIndex = '';
      this.reserveObj.jsIdx = '';

      let _this = this;
      Seat.loadTypeList(this.reserveObj,function(res){
        _this.sdList = res;
      });
    },
    initRq(){
      this.rqname = ''; 
      this.reserveObj.orderDate = '';
      this.reserveObj.rqIdx = '';

      this.sdname = ''; 
      this.reserveObj.type = '';
      this.reserveObj.sdIdx = '';

      this.ksname = ''; 
      this.reserveObj.startHourStr = '';
      this.reserveObj.ksIdx = '';

      this.jsname = ''; 
      this.reserveObj.endIndex = '';
      this.reserveObj.jsIdx = '';


      let _this = this;
      var startHourNxt = 8;
      var preholdMins=10;
      if (preholdMins == null || preholdMins == undefined || preholdMins == 'undefined') {
        preholdMins = '10';
      }

      //var ahead;
	  // TODO 开始
      // var nowT = new Date();
      // let days = 1;
      // if(nowT.getHours() >= Number(startHourNxt)){
      //   days = 2;
      // }else{
      //   days = 1;
      // }
	  // TODO 结束
	  var nowT = new Date();
	  let days = parseInt(sessionStorage.getItem("config_seat_maxday"));
	  days = days > 0 ? days : 7;

      Seat.getAhead(days,function(res){
         _this.rqList = res;
      });
      var paramsJson = {
        "libraryId": this.reserveObj.libId+''
      };
      loadData('/appSeat/queryLibOpenhours',paramsJson).then(response => {
        if(response && response.code == 0){
          _this.reserveObj.openHourJsonData = response.data;
        }
      }).catch(() => {
        //this.listLoading = false
      })
    },
    onCancel() {
      Toast('取消');
    },
    NextStep(){
      let libId = this.reserveObj.libId;
      let orderDate = this.reserveObj.orderDate;
      let type = 1;
      let startHourStr = this.reserveObj.startHourStr;
      let endIndex = this.reserveObj.endIndex;
      if(!(libId && orderDate && type && startHourStr && endIndex)){
        Toast('预约数据异常请重新选择！');
        return;
      }
      let rdata = {};
      rdata.libId = libId;
      rdata.orderDate = orderDate;
      rdata.type = type;
      rdata.startHourStr = startHourStr;
      rdata.endIndex = endIndex;
      this.$emit("notice",  {'page':'library','rdata':rdata})
    }
  }
}
</script>
